
export type EsnButtonVariant = 'primary' | 'secondary' | 'outline' | 'danger-outline' | 'text' | 'link';
export type EsnButtonSize = 'md' | 'sm' | 'xs';
/**
 * 32 inside cards/cells, 40 for the accounts row's actions trigger, 44 where a thumb has to land.
 */
export type EsnIconButtonSize = 32 | 40 | 44;
export type EsnIconButtonFill = 'filled' | 'transparent';
export type EsnStatus =
  | 'published'
  | 'ready'
  | 'active'
  | 'draft'
  | 'processing'
  | 'archived'
  | 'error'
  | 'invited'
  | 'deactivated'
  | 'testing'
  | 'staging';
export type EsnRole = 'admin' | 'editor' | 'viewer';
export type EsnLogoVariant = 'full' | 'compact' | 'mark' | 'wordmark';
export type EsnContentType = 'image' | 'video' | 'audio' | 'model-3d' | 'document';

/**
 * Avatar fallback: first letters of the first and last name ("Mia Müller" → "MM"), one letter for a single name.
 */
export function esnInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  const first = Array.from(words[0])[0] ?? '';
  const last = words.length > 1 ? (Array.from(words[words.length - 1])[0] ?? '') : '';
  return (first + last).toLocaleUpperCase();
}
